import React, { FC } from 'react';
import { EstimateReminder } from '../estimates.model';
import { EditIconBlue } from 'assets/icons';
import { formatReminderText } from 'containers/settings/utils';
import { transformEstimateApiRemindersToComponentFormat } from '../utils';
import { ReminderDateTypeLabel } from 'containers/settings/constants';

interface DetailEstimateReminderProps {
  reminders: EstimateReminder[];
  isEditAllowed: boolean;
  onEditClick: () => void;
}

const DetailEstimateReminder: FC<DetailEstimateReminderProps> = ({ reminders, isEditAllowed, onEditClick }) => {
  const visibleReminders = reminders?.slice(0, 2);
  const remainingCount = reminders?.length - 2;

  const reminderConfigs = transformEstimateApiRemindersToComponentFormat(visibleReminders);

  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-sbase font-bold text-primaryText">{`Estimate reminders (${reminders?.length ?? 0})`}</div>
      <div className="rounded-md border border-borderGray p-3 pr-4">
        <div className="flex items-start justify-between">
          <div className="text-sbase font-semibold text-primaryText">
            {reminderConfigs?.map((reminderConfig, index) => (
              <span key={reminderConfig.id || index}>
                {formatReminderText(reminderConfig, ReminderDateTypeLabel.EXPIRY_DATE, false)}
                {index < reminderConfigs.length - 1 && ' , '}
              </span>
            ))}
            {remainingCount > 0 && <span className="text-primaryBtn"> ...+{remainingCount}</span>}
            {reminderConfigs.length === 0 && <span className="text-accentText">No reminders configured</span>}
          </div>
          {isEditAllowed && (
            <EditIconBlue
              className="h-[18px] w-[18px] shrink-0 cursor-pointer"
              onClick={onEditClick}
              role="presentation"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailEstimateReminder;
